<template>
    <div>
        <!-- 顶部标签导航 -->
        <el-tabs v-model="activeTab" type="card" tab-position="top" class="carousel-tabs" @tab-click="handleTabClick">
            <el-tab-pane label="骰子游戏记录" name="manage"></el-tab-pane>
            <el-tab-pane label="骰子游戏设置" name="setting"></el-tab-pane>
        </el-tabs>

        <!-- 设置页面 -->
        <div v-if="activeTab === 'setting'">
            <div class="carousel-banner">
                <div class="carousel-banner-title">骰子游戏设置</div>
            </div>
            <el-card class="carousel-setting-card">

                <el-form label-width="120px" style="max-width: 500px; margin: 0 auto;">


                    <el-form-item label="是否启用：">
                        <el-switch v-model="Diceconfig.isEnable" class="big-switch" />
                    </el-form-item>


                    <el-form-item label="游戏链接关键词">
                        <div class="keyword-tags-input">
                            <el-tag v-for="tag in Diceconfig.keywordList" :key="tag" closable
                                :disable-transitions="false" @close="handleKeywordTagClose(tag)">
                                {{ tag }}
                            </el-tag>
                            <input type="text" class="keyword-new-tag-input" v-model="keyword_input"
                                @keyup.enter="handleKeywordInputConfirm" placeholder="输入后按回车" />
                        </div>
                    </el-form-item>


                    <el-form-item label="消耗积分">
                        <el-input v-model="Diceconfig.pointNum" placeholder="请输入消耗积分" />
                    </el-form-item>


                    <el-form-item label="收佣比例">
                        <el-input v-model="Diceconfig.taxRate" placeholder="请输入收佣比例">
                            <template #append>%</template>
                        </el-input>
                    </el-form-item>



                    <el-form-item label="每局时间">
                        <el-input v-model="Diceconfig.gameMinutes" placeholder="请输入每局时间">
                            <template #append>分钟</template>
                        </el-input>
                    </el-form-item>



                    <el-form-item prop="contentType" label-width="10px">
                        <div class="reply-type-horizontal">
                            <div class="type-select-container">
                                <span style="white-space: nowrap; margin-right: 10px;">游戏通知</span>
                                <el-select v-model="Diceconfig.msgType" placeholder="请选择内容类型" style="width: 150px;"
                                    popper-class="reply-type-dropdown">
                                    <el-option label="文本内容" value="text"></el-option>
                                    <el-option label="图片" value="photo"></el-option>
                                    <el-option label="视频" value="video"></el-option>
                                </el-select>
                            </div>
                            <div class="media-url-container"
                                v-if="Diceconfig.msgType === 'photo' || Diceconfig.msgType === 'video'">
                                <span style="white-space: nowrap; margin-right: 10px; color: #606266; font-size: 14px;">
                                    {{ { photo: '图片', video: '视频' }[Diceconfig.msgType] }}地址：
                                </span>
                                <el-input v-model="Diceconfig.fileUrl"
                                    :placeholder="`请输入${{ photo: '图片', video: '视频' }[Diceconfig.msgType]}的URL地址`"
                                    style="flex: 1; min-width: 200px;" />
                            </div>
                        </div>
                    </el-form-item>



                    <el-form-item prop="replaytext" label="" label-width="120px">
                        <div :key="editorMyLinkKey" class="html-editor">
                            <!-- 简单的 HTML 工具栏 -->
                            <div class="html-toolbar">
                                <button @click="insertHtmlMyLink('<b>', '</b>')" type="button" title="加粗">
                                    <strong>B</strong>
                                </button>
                                <button @click="insertHtmlMyLink('<i>', '</i>')" type="button" title="斜体">
                                    <em>I</em>
                                </button>
                                <button @click="insertHtmlMyLink('<u>', '</u>')" type="button" title="下划线">
                                    <u>U</u>
                                </button>
                                <button @click="insertHtmlMyLink('<br>')" type="button" title="换行">
                                    换行
                                </button>
                                <span class="divider">|</span>
                                <button @click="insertHtmlMyLink('<h1>', '</h1>')" type="button" title="标题1">
                                    H1
                                </button>
                                <button @click="insertHtmlMyLink('<h2>', '</h2>')" type="button" title="标题2">
                                    H2
                                </button>
                                <span class="divider">|</span>
                                <button @click="insertHtmlMyLink('<ul><li>', '</li></ul>')" type="button" title="无序列表">
                                    • 列表
                                </button>
                                <button @click="insertHtmlMyLink('<ol><li>', '</li></ol>')" type="button" title="有序列表">
                                    1. 列表
                                </button>
                                <span class="divider">|</span>
                                <button @click="toggleModeMyLink" type="button"
                                    :title="isSourceModeMyLink ? '切换到可视化模式' : '切换到源码模式'"
                                    :class="{ 'is-active': isSourceModeMyLink }">
                                    {{ isSourceModeMyLink ? '可视' : '源码' }}
                                </button>
                            </div>
                            <!-- 编辑器内容区域 -->
                            <div class="editor-content-area">
                                <!-- 可视化编辑模式 -->
                                <div v-if="!isSourceModeMyLink" ref="visualEditorMyLink" class="visual-editor"
                                    contenteditable="true" @input="handleVisualInputMyLink"
                                    @compositionstart="handleCompositionStartMyLink"
                                    @compositionend="handleCompositionEndMyLink" @paste="handlePasteMyLink"
                                    @keydown="handleKeydownMyLink">
                                </div>
                                <!-- 源码编辑模式 -->
                                <el-input v-if="isSourceModeMyLink" ref="htmlTextareaMyLink"
                                    v-model="Diceconfig.myLinkHtml" type="textarea" :rows="8"
                                    placeholder="请输入内容，支持HTML标签..." class="html-textarea" />
                            </div>
                        </div>
                    </el-form-item>


                    <div class="variable-help-text">
                        <span class="variable-item"><code>{qi}</code>为当前期数，</span>
                        <span class="variable-item"><code>{gameMinute}</code>为参与分钟数，</span>
                        <span class="variable-item"><code>{pointNum}</code>为消耗积分，</span>
                        <span class="variable-item"><code>{taxRate}</code>为收佣比例，</span>
                        <span class="variable-item"><code>{joinNum}</code>为已参与人数，</span>
                        <span class="variable-item"><code>{joinList}</code>为已参与人列表，</span>
                        <span class="variable-item"><code>{poolNum}</code>为当前奖金池积分，</span>
                        <span class="variable-item"><code>{openTime}</code>为开盘时间</span>
                    </div>



                    <!-- 附加按钮 -->
                    <el-form-item prop="buttons" label="附加按钮" label-width="80px">
                        <!-- 按钮行列表 -->
                        <div v-if="Diceconfig.successBtnList.length > 0" class="button-rows-list">
                            <div v-for="(row, rowIndex) in Diceconfig.successBtnList"
                                :key="`row-${rowIndex}-${JSON.stringify(row)}`" class="button-row-wrapper"
                                @dragover="handleDragOver" @drop="handleDrop($event, rowIndex, 'success')"
                                :class="{ 'drag-over': draggedRowIndex !== null && draggedRowIndex !== rowIndex }">
                                <!-- 灰色按钮容器 -->
                                <div class="gray-buttons-container">
                                    <div v-for="(button, btnIndex) in row" :key="btnIndex" class="button-item">
                                        {{ button.text || '按钮' }}
                                        <div class="button-actions">
                                            <div class="button-action-icon edit-icon"
                                                @click="editButton(rowIndex, btnIndex, 'success')" title="编辑按钮">
                                                <el-icon>
                                                    <Edit />
                                                </el-icon>
                                            </div>
                                            <div class="button-action-icon delete-icon"
                                                @click="removeButton(rowIndex, btnIndex, 'success')" title="删除按钮">
                                                <el-icon>
                                                    <Delete />
                                                </el-icon>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- 只有当行数 >= 1 时，才显示"本行新增一个按钮" -->
                                <div v-if="Diceconfig.successBtnList.length >= 1" class="add-button-container">
                                    <button @click="showAddButtonDialog(rowIndex, 'success')" type="button"
                                        class="add-to-row-button">
                                        + 本行新增一个按钮
                                    </button>
                                </div>
                                <!-- 右侧拖拽图标 -->
                                <div class="drag-icon-container" :title="'拖拽移动第' + (rowIndex + 1) + '行'"
                                    draggable="true" @dragstart="handleDragStart(rowIndex)" @dragend="handleDragEnd">
                                    <el-icon class="drag-icon">
                                        <Rank />
                                    </el-icon>
                                </div>
                            </div>
                        </div>

                        <!-- 新增一行按钮 -->
                        <div class="button-controls">
                            <button @click="showAddButtonDialog(-1, 'success')" type="button" class="add-row-button">
                                + 新增一行按钮
                            </button>
                        </div>
                    </el-form-item>

                    <!-- 添加按钮对话框 -->
                    <el-dialog v-model="buttonDialogVisible" :title="getDialogTitle()" width="600px"
                        :close-on-click-modal="false" destroy-on-close>
                        <el-form :model="buttonForm" :rules="buttonRules" ref="buttonFormRef" label-width="80px">
                            <el-form-item label="按钮文字" prop="text">
                                <el-input v-model="buttonForm.text" placeholder="请输入按钮文字" />
                            </el-form-item>
                            <el-form-item label="链接" prop="url">
                                <el-input v-model="buttonForm.url" placeholder="请输入http(s)://开头的链接或tg://开头的链接" />
                            </el-form-item>
                        </el-form>
                        <template #footer>
                            <div class="dialog-footer">
                                <el-button @click="buttonDialogVisible = false">取消</el-button>
                                <el-button type="primary" @click="confirmAddButton">确定</el-button>
                            </div>
                        </template>
                    </el-dialog>




                    <el-form-item prop="replaytext" label="开盘成功通知" label-width="120px">
                        <div :key="editorSuccessKey" class="html-editor">
                            <!-- 简单的 HTML 工具栏 -->
                            <div class="html-toolbar">
                                <button @click="insertHtmlSuccess('<b>', '</b>')" type="button" title="加粗">
                                    <strong>B</strong>
                                </button>
                                <button @click="insertHtmlSuccess('<i>', '</i>')" type="button" title="斜体">
                                    <em>I</em>
                                </button>
                                <button @click="insertHtmlSuccess('<u>', '</u>')" type="button" title="下划线">
                                    <u>U</u>
                                </button>
                                <button @click="insertHtmlSuccess('<br>')" type="button" title="换行">
                                    换行
                                </button>
                                <span class="divider">|</span>
                                <button @click="insertHtmlSuccess('<h1>', '</h1>')" type="button" title="标题1">
                                    H1
                                </button>
                                <button @click="insertHtmlSuccess('<h2>', '</h2>')" type="button" title="标题2">
                                    H2
                                </button>
                                <span class="divider">|</span>
                                <button @click="insertHtmlSuccess('<ul><li>', '</li></ul>')" type="button" title="无序列表">
                                    • 列表
                                </button>
                                <button @click="insertHtmlSuccess('<ol><li>', '</li></ol>')" type="button" title="有序列表">
                                    1. 列表
                                </button>
                                <span class="divider">|</span>
                                <button @click="toggleModeSuccess" type="button"
                                    :title="isSourceModeSuccess ? '切换到可视化模式' : '切换到源码模式'"
                                    :class="{ 'is-active': isSourceModeSuccess }">
                                    {{ isSourceModeSuccess ? '可视' : '源码' }}
                                </button>
                            </div>
                            <!-- 编辑器内容区域 -->
                            <div class="editor-content-area">
                                <!-- 可视化编辑模式 -->
                                <div v-if="!isSourceModeSuccess" ref="visualEditorSuccess" class="visual-editor"
                                    contenteditable="true" @input="handleVisualInputSuccess"
                                    @compositionstart="handleCompositionStartSuccess"
                                    @compositionend="handleCompositionEndSuccess" @paste="handlePasteSuccess"
                                    @keydown="handleKeydownSuccess">
                                </div>
                                <!-- 源码编辑模式 -->
                                <el-input v-if="isSourceModeSuccess" ref="htmlTextareaSuccess"
                                    v-model="Diceconfig.successHtml" type="textarea" :rows="8"
                                    placeholder="请输入内容，支持HTML标签..." class="html-textarea" />
                            </div>
                        </div>
                    </el-form-item>


                    <div class="variable-help-text">
                        <span class="variable-item"><code>{qi}</code>为当前期数，</span>
                        <span class="variable-item"><code>{diceResult}</code>为骰子结果，</span>
                        <span class="variable-item"><code>{winResult}</code>为输赢情况，</span>
                        <span class="variable-item"><code>{taxPointNum}</code>为佣金，</span>
                        <span class="variable-item"><code>{poolNum}</code>为奖金池，</span>
                        <span class="variable-item"><code>{joinNum}</code>为已参与人数，</span>
                        <span class="variable-item"><code>{joinList}</code>为已参与人列表</span>
                    </div>





                    <el-form-item>
                        <div style="display: flex; justify-content: space-between; width: 100%;">
                            <el-button type="primary" class="big-submit-btn"
                                @click="handleNotificationPreview">预览</el-button>
                            <el-button type="primary" class="big-submit-btn" @click="saveSetting">提交</el-button>
                        </div>
                    </el-form-item>


                </el-form>
            </el-card>
        </div>

        <!-- 列表页面 -->
        <div v-else>
            <!-- 原有内容保持不变 -->
            <div class="auto-reply">
                <div class="search-section">
                    <el-form :inline="true" :model="searchForm" class="demo-form-inline">

                        <el-form-item>
                            <div class="button-group">
                                <el-button type="success" @click="onSearch" size="large">
                                    <el-icon>
                                        <Search />
                                    </el-icon>
                                    刷新
                                </el-button>

                                <el-button type="warning" @click="handleImport" size="large">
                                    <el-icon>
                                        <Upload />
                                    </el-icon>
                                    导入
                                </el-button>
                                <el-button type="info" @click="handleExport" size="large">
                                    <el-icon>
                                        <Download />
                                    </el-icon>
                                    导出
                                </el-button>
                            </div>
                        </el-form-item>
                    </el-form>
                </div>



                <el-divider></el-divider>

                <!-- 数据表格 -->
                <el-table :data="tableData" style="width: 100%" v-loading="loading">


                    <el-table-column prop="qiNum" label="期数" min-width="120">
                        <template #default="scope">
                            {{ scope.row.qiNum }}
                        </template>
                    </el-table-column>


                    <el-table-column prop="joinUserNum" label="参与人数" min-width="100">
                        <template #default="scope">
                            {{ scope.row.joinUserNum }}
                        </template>
                    </el-table-column>


                    <el-table-column prop="pointNum" label="每人消耗积分" min-width="120">
                        <template #default="scope">
                            {{ scope.row.pointNum }}
                        </template>
                    </el-table-column>


                    <el-table-column prop="diceNum" label="骰子结果" min-width="120">
                        <template #default="scope">
                            <div class="dice-container">
                                <div class="dice" :class="`dice-${scope.row.diceNum}`">
                                    <div class="dice-inner">
                                        <div class="dice-dots">
                                            <span v-for="dot in getDiceDots(scope.row.diceNum)" :key="dot"
                                                class="dot"></span>
                                        </div>
                                    </div>
                                </div>
                                <!-- <span class="dice-number">{{ scope.row.diceNum }}</span> -->
                            </div>
                        </template>
                    </el-table-column>




                    <el-table-column prop="totalPointNum" label="奖池总积分" min-width="100">
                        <template #default="scope">
                            {{ scope.row.totalPointNum }}
                        </template>
                    </el-table-column>



                    <el-table-column prop="winUserNum" label="获胜人数" min-width="100">
                        <template #default="scope">
                            <el-tag type="primary" size="small">
                                {{ scope.row.winUserNum }}
                            </el-tag>
                        </template>
                    </el-table-column>


                    <el-table-column prop="winPointNum" label="被瓜分积分" min-width="100">
                        <template #default="scope">
                            <el-tag type="danger" size="small">
                                {{ scope.row.winPointNum }}
                            </el-tag>
                        </template>
                    </el-table-column>

                    <el-table-column prop="taxPointNum" label="系统收佣积分" min-width="150">
                        <template #default="scope">
                            <el-tag type="warning" size="small">
                                {{ scope.row.taxPointNum }}
                            </el-tag>
                        </template>
                    </el-table-column>


                    <el-table-column prop="restPointNum" label="奖池剩余积分" min-width="150">
                        <template #default="scope">
                            <el-tag type="success" size="small">
                                {{ scope.row.restPointNum }}
                            </el-tag>
                        </template>
                    </el-table-column>





                    <el-table-column prop="createTime" label="创建时间" min-width="150">
                        <template #default="scope">
                            {{ formatDateTime(scope.row.createTime) }}
                        </template>
                    </el-table-column>


                    <!-- <el-table-column prop="stopTime" label="停止时间" min-width="150">
                        <template #default="scope">
                            {{ formatDateTime2(scope.row.stopTime) }}
                        </template>
                    </el-table-column> -->



                    <el-table-column prop="openTime" label="开盘时间" min-width="150">
                        <template #default="scope">
                            {{ formatDateTime2(scope.row.openTime) }}
                        </template>
                    </el-table-column>







                    <el-table-column label="操作" width="280" fixed="right">
                        <template #default="scope">
                            <el-button type="primary" size="small" @click="handleDetail(scope.row)">
                                <el-icon>
                                    <ViewIcon />
                                </el-icon>
                                详情
                            </el-button>
                            <el-button type="danger" size="small" @click="handleOpen(scope.row)">
                                <el-icon>
                                    <Edit />
                                </el-icon>
                                开奖
                            </el-button>
                        </template>
                    </el-table-column>







                </el-table>

                <!-- 分页组件 -->
                <div class="pagination">
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper" :total="total">
                    </el-pagination>
                </div>



                <!-- 导入对话框 -->
                <el-dialog v-model="importVisible" title="导入骰子游戏记录（JSON格式）" width="600px">
                    <el-input type="textarea" v-model="jsonInput" :rows="8"
                        placeholder="可粘贴 JSON 或拖拽上传 .json 文件，将自动提取数组数据" style="margin-bottom: 16px;" />
                    <div style="margin-bottom: 16px; display: flex; gap: 8px; align-items: center;">
                        <el-button size="small" @click="toggleJsonFormat" :disabled="!jsonInput">
                            <el-icon>
                                <ViewIcon />
                            </el-icon>
                            {{ isFormatted ? '压缩显示' : '格式化显示' }}
                        </el-button>
                        <span v-if="previewCount > 0" style="color: #67c23a; font-size: 14px;">
                            已识别到 {{ previewCount }} 条数据
                        </span>
                    </div>
                    <el-upload :show-file-list="false" accept=".json,application/json" :before-upload="handleJsonFile"
                        drag class="json-upload-drag">
                        <el-icon class="el-icon--upload">
                            <Upload />
                        </el-icon>
                        <div class="el-upload__text">
                            将文件拖到此处，或<em>点击上传</em>
                        </div>
                        <template #tip>
                            <div class="el-upload__tip">
                                支持粘贴或上传 JSON 文件，格式如：{ code, data: { records: [...] } }<br>
                                将自动提取数组数据并压缩显示，字段需与导出格式一致。支持骰子游戏记录和用户参与记录。
                            </div>
                        </template>
                    </el-upload>
                    <template #footer>
                        <div class="dialog-footer">
                            <el-button @click="importVisible = false">取消</el-button>
                            <el-button type="primary" @click="confirmImport" :loading="importLoading"
                                :disabled="!jsonInput">
                                {{ importLoading ? '正在导入...' : '确定导入' }}
                            </el-button>
                        </div>
                    </template>
                </el-dialog>

                <!-- 邀请详情弹窗 -->
                <el-dialog v-model="detailDialogVisible" title="骰子游戏用户参与详情" width="1200px"
                    :close-on-click-modal="false">
                    <div v-loading="diceuserHisLoading">

                        <el-table :data="diceuserHisData" style="width: 100%">
                            <el-table-column prop="userId" label="用户ID" min-width="120">
                                <template #default="scope">
                                    {{ scope.row.userId }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="userName" label="用户名" min-width="150">
                                <template #default="scope">
                                    {{ scope.row.userName }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="nickname" label="昵称" min-width="200">
                                <template #default="scope">
                                    {{ scope.row.nickname }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="diceDes" label="游戏选择" min-width="100">
                                <template #default="scope">
                                    <el-tag :type="getChoiceTagType(scope.row.diceDes)" size="small">
                                        {{ scope.row.diceDes }}
                                    </el-tag>
                                </template>
                            </el-table-column>
                            <el-table-column prop="pointNum" label="参与积分" min-width="100">
                                <template #default="scope">
                                    {{ scope.row.pointNum }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="diceNum" label="骰子点数" min-width="100">
                                <template #default="scope">
                                    <el-tag type="info" size="small">
                                        {{ scope.row.diceNum }}
                                    </el-tag>
                                </template>
                            </el-table-column>
                            <el-table-column prop="isWin" label="是否获胜" min-width="100">
                                <template #default="scope">
                                    <el-tag :type="scope.row.isWin === 1 ? 'success' : 'danger'" size="small">
                                        {{ scope.row.isWin === 1 ? '是' : '否' }}
                                    </el-tag>
                                </template>
                            </el-table-column>
                            <el-table-column prop="winPointNum" label="获得积分" min-width="100">
                                <template #default="scope">
                                    {{ scope.row.winPointNum || 0 }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="taxPointNum" label="佣金积分" min-width="100">
                                <template #default="scope">
                                    {{ scope.row.taxPointNum || 0 }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="createTime" label="参与时间" min-width="150">
                                <template #default="scope">
                                    {{ formatDateTime(scope.row.createTime) }}
                                </template>
                            </el-table-column>
                        </el-table>

                        <!-- 分页组件 -->
                        <div class="pagination" style="margin-top: 20px;">
                            <el-pagination @size-change="handleInviteUsersSizeChange"
                                @current-change="handleInviteUsersPageChange" :current-page="diceuserHisCurrentPage"
                                :page-sizes="[10, 20, 50, 100]" :page-size="diceuserHisPageSize"
                                layout="total, sizes, prev, pager, next, jumper" :total="diceuserHisTotal">
                            </el-pagination>
                        </div>
                    </div>
                </el-dialog>
            </div>
        </div>
    </div>
</template>

<script>
import { Edit, Delete, Upload, Download, Rank, View as ViewIcon, Search } from '@element-plus/icons-vue'
import api from '@/services/api'

export default {
    name: 'AutoReply',
    components: {
        Edit,
        Delete,
        Upload,
        Download,
        Rank,
        ViewIcon,
        Search
    },
    data() {
        return {
            Diceconfig: {
                isEnable: false,
                keywordList: ['来一局'],
                msgType: 'text',
                fileUrl: '',
                pointNum: 100,
                taxRate: 10,
                gameMinutes: 5,
                successBtnList: [],
                myLinkHtml: '🎟️ 积分骰子游戏第{qi}期<br><br>🪧 游戏说明：机器人会在开盘时间自动摇骰子，赢方将瓜分输方的{pointAlias}，如果没有赢方，参与的{pointAlias} 自动划到奖金池，留给下次赢方瓜分。本次参与需扣除{pointNum}{pointAlias}，系统会收取赢方{taxRate}%的佣金<br><br>🔗如何参与：请用大、小、单、双的其中一个字回复本消息（或者点击下方任一的按钮）<br><br>🪙 当前奖金池：{poolNum}{pointAlias}<br><br>🎰已参与人({joinNum}):{joinList}<br><br>📅 本期开盘时间：{openTime}',
                successHtml: '🎟️ 积分骰子游戏第{qi}期结果：{diceResult}<br><br>👉输赢情况：{winResult}<br><br>🧾系统抽佣：{taxPointNum}{pointAlias}<br><br>🪙 当前奖金池：{poolNum}{pointAlias}<br><br>🎰已参与人({joinNum}):{joinList}<br><br>📅 本期开盘时间：{openTime}',
            },
            tableData: [],
            currentPage: 1,
            pageSize: 20,
            total: 0,
            loading: false,
            statsVisible: false,
            stats: {
                overview: null
            },
            dialogType: 'create',
            importVisible: false,
            importLoading: false,
            selectedFile: null,
            currentUserInfo: {
                userid: null,
                groupid: null,
                userBot: null
            },
            form: {
                userBot: null,
                groupid: null,
                userid: null,
                buttons: []
            },
            rules: {
                msgContent: [
                    {
                        required: true,
                        message: '请输入轮播文本内容',
                        trigger: 'blur',
                        validator: (rule, value, callback) => {

                            if (!value || value.trim() === '') {
                                callback(new Error('请输入轮播文本内容'));
                            } else {
                                callback();
                            }
                        }
                    }
                ],
                endTime: [
                    {
                        validator: (rule, value, callback) => {
                            if (value && this.form.startTime && value <= this.form.startTime) {
                                callback(new Error('结束时间必须晚于开始时间'));
                            } else {
                                callback();
                            }
                        },
                        trigger: 'change'
                    }
                ]
            },
            // 富文本编辑器相关数据
            isSourceMode: false,
            isComposing: false,
            updateTimer: null,
            // 两个富文本编辑器的独立状态
            isSourceModeMyLink: false,
            isSourceModeSuccess: false,
            editorMyLinkKey: 'myLink',
            editorSuccessKey: 'success',
            // 关键词输入
            keyword_input: '',
            // 按钮相关数据
            buttonForm: {
                text: '',
                url: ''
            },
            buttonDialogVisible: false,
            editingButtonRowIndex: -1,
            editingButtonIndex: -1,
            currentRowIndex: -1,
            draggedRowIndex: null,

            buttonRules: {
                text: [
                    { required: true, message: '请输入按钮文字', trigger: 'blur' }
                ],
                url: [
                    { required: true, message: '请输入链接地址', trigger: 'blur' },
                    {
                        validator(rule, value, callback) {
                            if (/^(https?:\/\/|tg:\/\/).+/.test(value)) {
                                callback(); // 合法链接：http://、https:// 或 tg:// 开头
                            } else {
                                callback(new Error('链接地址必须以 http://、https:// 或 tg:// 开头'));
                            }
                        },
                        trigger: 'blur'
                    }
                ]
            },
            activeTab: 'manage',
            setting: {
                enabled: true,
                interval: 5,
                mode: 'send_and_pin',
                cancelLastPin: false,
                deleteLastAd: false
            },
            jsonInput: '',
            previewCount: 0,
            isFormatted: false,

            currentBtnListType: 'success', // 当前操作的按钮列表类型：只有 'success'
            // 骰子游戏用户参与详情弹窗相关数据
            detailDialogVisible: false,
            diceuserHisData: [],
            diceuserHisLoading: false,
            diceuserHisCurrentPage: 1,
            diceuserHisPageSize: 10,
            diceuserHisTotal: 0,
            currentqiNum: null,
            currentGroupId: null
        }
    },
    computed: {
        vuexUser() {
            return this.$store.state.user;
        }
    },
    watch: {
        vuexUser: {
            handler(newUser) {
                if (newUser) {
                    this.loadUserInfo(newUser);
                }
            },
            deep: true,
            immediate: true
        },
        jsonInput: {
            handler(newValue) {
                if (newValue && newValue.trim()) {
                    this.processJsonInput(newValue);
                } else {
                    this.previewCount = 0;
                }
            },
            immediate: false
        }
    },
    methods: {

        // 获取骰子点数对应的圆点数量
        getDiceDots(diceNum) {
            const dotsMap = {
                1: [1],
                2: [1, 2],
                3: [1, 2, 3],
                4: [1, 2, 3, 4],
                5: [1, 2, 3, 4, 5],
                6: [1, 2, 3, 4, 5, 6]
            };
            return dotsMap[diceNum] || [];
        },

        handleTabClick(tab) {
            // console.log('标签点击:', JSON.stringify(tab));
            if (tab.paneName == 'manage') {
                this.fetchData()
            } else if (tab.paneName == 'setting') {
                this.initRichTextEditor();
                this.fetchSetting()
            }
        },

        fetchSetting() {
            // return;
            /////////调用group表的对应api接口获取群的配置
            api.getGroupById(this.currentUserInfo.groupId).then(res => {
                if (res.data.Diceconfig && res.data.Diceconfig != null && res.data.Diceconfig != '') {
                    this.Diceconfig = res.data.Diceconfig;
                }
            }).catch(error => {
                this.$message.error('获取骰子游戏配置失败: ' + (error.response?.data?.message || error.message || '网络错误'));
            });
        },



        async handleNotificationPreview(type) {
            this.$message.info('正在发送预览消息...')

            try {
                const params = {
                    type: type,
                    Diceconfig: this.Diceconfig,
                    userBot: this.currentUserInfo.userBot,
                    userid: this.currentUserInfo.userId
                };

                const response = await api.dicepreview(params);

                if (response.data.code === 0) {
                    this.$message.success(response.data.message || '预览成功，请去电报查看预览结果');
                } else {
                    this.$message.error(response.data.message || '预览失败');
                }
            } catch (error) {
                console.error('预览失败:', error);
                this.$message.error('预览失败');
            }


        },

        // 处理关键词标签关闭
        handleKeywordTagClose(tag) {
            const index = this.Diceconfig.keywordList.indexOf(tag);
            if (index > -1) {
                this.Diceconfig.keywordList.splice(index, 1);
            }
        },

        // 处理关键词输入确认
        handleKeywordInputConfirm() {
            const inputValue = this.keyword_input.trim();
            if (inputValue && !this.Diceconfig.keywordList.includes(inputValue)) {
                this.Diceconfig.keywordList.push(inputValue);
            }
            this.keyword_input = '';
        },

        saveSetting() {
            if (this.Diceconfig.msgType == 'text' && this.Diceconfig.fileUrl !== '') {
                this.Diceconfig.fileUrl = '';
            }
            api.updateDiceConfig(this.currentUserInfo.groupId, {
                Diceconfig: this.Diceconfig
            }).then(res => {
                if (res.data.code == 0) {
                    this.$message.success('骰子游戏配置保存成功');
                    this.fetchSetting();
                } else {
                    this.$message.error(res.data.message || '保存失败');
                }
            }).catch(error => {
                this.$message.error('保存失败: ' + (error.response?.data?.message || error.message || '网络错误'));
            });
        },



        loadUserInfo(user) {
            this.currentUserInfo.userId = user.userId;
            this.currentUserInfo.groupId = user.groupId;
            this.currentUserInfo.userBot = user.userBot;
        },


        onSearch() {
            this.currentPage = 1
            this.fetchData()
        },


        async fetchData() {
            this.loading = true
            try {
                const params = {
                    page: this.currentPage,
                    pageSize: this.pageSize,
                    userBot: this.currentUserInfo.userBot,
                    groupid: this.currentUserInfo.groupId
                }


                const response = await api.getDicepointHisList(params)

                if (response.data.code === 0) {
                    this.tableData = response.data.data.records
                    this.total = response.data.data.total
                } else {
                    this.$message.error(response.data.message || '获取数据失败')
                }
            } catch (error) {
                console.error('获取骰子游戏记录失败:', error)
                this.$message.error('获取数据失败')
            } finally {
                this.loading = false
            }
        },
        handleSizeChange(val) {
            this.pageSize = val
            this.currentPage = 1
            this.fetchData()
        },
        handleCurrentChange(val) {
            this.currentPage = val
            this.fetchData()
        },


        handleImport() {
            this.importVisible = true
            this.jsonInput = ''
            this.previewCount = 0
            this.isFormatted = false
        },
        async handleJsonFile(file) {
            // 读取本地json文件内容并填充到textarea
            const reader = new FileReader();
            reader.onload = (e) => {
                this.jsonInput = e.target.result;
                // 自动处理文件内容
                this.processJsonInput(e.target.result);
            };
            reader.onerror = () => {
                this.$message.error('文件读取失败');
            };
            reader.readAsText(file);
            // 阻止el-upload自动上传
            return false;
        },
        processJsonInput(input) {
            if (!input || !input.trim()) {
                this.previewCount = 0;
                return;
            }
            try {
                const data = JSON.parse(input);
                let records = [];

                // 自动识别格式并提取数组
                if (data && typeof data === 'object' && data.data && Array.isArray(data.data.records)) {
                    records = data.data.records;
                } else if (Array.isArray(data.records)) {
                    records = data.records;
                } else if (Array.isArray(data)) {
                    records = data;
                }

                this.previewCount = records.length;

                if (records.length > 0) {
                    // 压缩显示数组数据
                    this.jsonInput = JSON.stringify(records);
                    this.isFormatted = false;
                    this.$message.success(`成功提取 ${records.length} 条数据`);
                } else {
                    this.$message.warning('未识别到有效的数据记录');
                }
            } catch (e) {
                this.previewCount = 0;
                // 如果不是有效JSON，保持原内容不变
            }
        },
        toggleJsonFormat() {
            if (!this.jsonInput) return;

            try {
                const data = JSON.parse(this.jsonInput);
                if (this.isFormatted) {
                    // 压缩显示
                    this.jsonInput = JSON.stringify(data);
                    this.isFormatted = false;
                } else {
                    // 格式化显示
                    this.jsonInput = JSON.stringify(data, null, 2);
                    this.isFormatted = true;
                }
            } catch (e) {
                this.$message.error('JSON 格式不正确');
            }
        },
        async confirmImport() {
            if (!this.jsonInput) {
                this.$message.warning('请粘贴或上传 JSON 数据');
                return;
            }
            let data;
            try {
                data = JSON.parse(this.jsonInput);
            } catch (e) {
                this.$message.error('JSON 格式不正确');
                return;
            }
            // 现在直接是数组数据
            let importData = data;
            if (!Array.isArray(data)) {
                this.$message.error('数据格式错误，请确保是数组格式');
                return;
            }

            // 添加用户信息
            const importPayload = {
                userBot: this.currentUserInfo.userBot,
                groupid: this.currentUserInfo.groupId,
                userid: this.currentUserInfo.userId,
                records: importData
            };

            this.importLoading = true;
            try {
                var response;
                if (importData[0].userId) {
                    response = await api.importDiceuserHis(importPayload);
                } else {
                    response = await api.importDicepointHis(importPayload);
                }




                if (response.data.code === 0) {
                    this.$message.success(`成功导入 ${response.data.data.importedCount} 条骰子游戏记录`);
                    this.importVisible = false;
                    this.fetchData();
                } else {
                    this.$message.error(response.data.message || '导入失败');
                }
            } catch (error) {
                this.$message.error('导入失败，请检查数据格式或联系管理员。');
            } finally {
                this.importLoading = false;
            }
        },
        async handleExport() {
            try {
                this.loading = true
                const response = await api.exportDicepointHis({
                    userBot: this.currentUserInfo.userBot,
                    groupid: this.currentUserInfo.groupId
                })
                if (response.data.code === 0) {
                    const exportData = response.data.data
                    this.exportToJson(exportData)
                    this.$message.success('骰子游戏记录导出成功')
                } else {
                    this.$message.error(response.data.message || '获取数据失败')
                }
            } catch (error) {
                console.error('导出骰子游戏记录失败:', error)
                this.$message.error('导出失败')
            } finally {
                this.loading = false
            }
        },

        // 导出为JSON文件
        exportToJson(exportData) {
            // 格式化JSON数据
            const jsonContent = JSON.stringify(exportData, null, 2)

            // 创建Blob对象
            const blob = new Blob([jsonContent], { type: 'application/json' })

            // 创建下载链接
            const url = URL.createObjectURL(blob)
            const link = document.createElement('a')
            link.href = url

            // 生成文件名
            const filename = `骰子游戏记录_${new Date().toISOString().split('T')[0]}.json`
            link.download = filename

            // 触发下载
            document.body.appendChild(link)
            link.click()

            // 清理
            document.body.removeChild(link)
            URL.revokeObjectURL(url)
        },
        getloacltime(row) {
            /////////把13位时间戳转换为 格式化时间
            return this.formatDateTime(row)
        },

        formatDateTime(dateTime) {
            if (!dateTime) return '-'
            const date = new Date(dateTime)
            return date.toLocaleString('zh-CN')
        },
        formatDateTime2(dateTime) {
            if (!dateTime) return '-'
            const ts = new Date(dateTime).getTime() - 8 * 60 * 60 * 1000
            return new Date(ts).toLocaleString('zh-CN')
        },
        removeButton(rowIndex, btnIndex, btnListType = 'success') {
            const btnList = this.Diceconfig.successBtnList;

            btnList[rowIndex].splice(btnIndex, 1);
            // 如果删除按钮后该行没有按钮了，则删除整行
            if (btnList[rowIndex].length === 0) {
                btnList.splice(rowIndex, 1);

                // 如果当前选中的行被删除了，重置状态
                if (this.currentRowIndex === rowIndex) {
                    this.currentRowIndex = -1;
                }
                // 如果删除的行在当前选中行之前，需要调整索引
                else if (this.currentRowIndex > rowIndex) {
                    this.currentRowIndex--;
                }
            }
        },
        addButton(rowIndex, btnListType = 'success') {
            const btnList = this.Diceconfig.successBtnList;
            btnList[rowIndex].push({ text: '', url: '' });
        },
        editButton(rowIndex, btnIndex, btnListType = 'success') {
            // 设置编辑状态
            this.editingButtonRowIndex = rowIndex;
            this.editingButtonIndex = btnIndex;
            this.currentRowIndex = rowIndex;
            this.currentBtnListType = btnListType;

            // 使用成功按钮列表
            const btnList = this.Diceconfig.successBtnList;

            // 填充表单数据
            const button = btnList[rowIndex][btnIndex];
            this.buttonForm.text = button.text;
            this.buttonForm.url = button.url;

            // 显示对话框
            this.buttonDialogVisible = true;
        },


        formatText(type) {
            const textarea = this.$refs.replaytextInput.$refs.textarea;
            if (!textarea) return;

            const start = textarea.selectionStart;
            const end = textarea.selectionEnd;
            const selectedText = this.form.msgContent.msgText.substring(start, end);
            let replacement = selectedText;
            let preSelection = 0;
            let postSelection = 0;

            switch (type) {
                case 'bold':
                    replacement = `**${selectedText}**`;
                    preSelection = 2;
                    postSelection = 2;
                    break;
                case 'italic':
                    replacement = `_${selectedText}_`;
                    preSelection = 1;
                    postSelection = 1;
                    break;
                case 'strikethrough':
                    replacement = `~${selectedText}~`;
                    preSelection = 1;
                    postSelection = 1;
                    break;
                case 'code':
                    replacement = `\`${selectedText}\``;
                    preSelection = 1;
                    postSelection = 1;
                    break;
                case 'link':
                    {
                        const url = prompt("请输入链接 URL:", "https://");
                        if (url) {
                            replacement = `[${selectedText}](${url})`;
                            preSelection = 1;
                            postSelection = url.length + 3 + (selectedText.length > 0 ? 0 : -selectedText.length);
                        } else {
                            return;
                        }
                        break;
                    }
            }

            this.form.msgContent.msgText = this.form.msgContent.msgText.substring(0, start) + replacement + this.form.msgContent.msgText.substring(end);

            this.$nextTick(() => {
                textarea.focus();
                if (selectedText.length === 0) {
                    const newCursorPos = start + preSelection;
                    textarea.setSelectionRange(newCursorPos, newCursorPos);
                } else {
                    const newStart = start + preSelection;
                    const newEnd = start + replacement.length - postSelection;
                    textarea.setSelectionRange(newStart, newEnd);
                }
            });
        },
        insertHtml(tag, closeTag) {
            // 这个方法已经被删除，使用独立的编辑器方法
        },
        toggleMode() {
            // 这个方法已经被删除，使用独立的编辑器方法
        },
        handleVisualInput(event) {
            // 这个方法已经被删除，使用独立的编辑器方法
        },
        handleCompositionStart() {
            // 这个方法已经被删除，使用独立的编辑器方法
        },
        handleCompositionEnd(event) {
            // 这个方法已经被删除，使用独立的编辑器方法
        },
        handlePaste() {
            // 这个方法已经被删除，使用独立的编辑器方法
        },
        handleKeydown() {
            // 这个方法已经被删除，使用独立的编辑器方法
        },
        setVisualEditorContent(content) {
            // 这个方法已经被删除，使用独立的编辑器方法
        },
        // 保存光标位置
        saveCaretPosition() {
            const selection = window.getSelection();
            if (selection.rangeCount > 0) {
                const range = selection.getRangeAt(0);
                const preCaretRange = range.cloneRange();
                preCaretRange.selectNodeContents(this.$refs.visualEditor);
                preCaretRange.setEnd(range.endContainer, range.endOffset);
                return preCaretRange.toString().length;
            }
            return 0;
        },

        // 恢复光标位置
        restoreCaretPosition(caretPos) {
            const editor = this.$refs.visualEditor;
            if (!editor) return;

            const selection = window.getSelection();
            const range = document.createRange();

            let charIndex = 0;
            let nodeStack = [editor];
            let node, foundStart = false;

            while (!foundStart && (node = nodeStack.pop())) {
                if (node.nodeType === Node.TEXT_NODE) {
                    const nextCharIndex = charIndex + node.textContent.length;
                    if (caretPos >= charIndex && caretPos <= nextCharIndex) {
                        range.setStart(node, caretPos - charIndex);
                        range.setEnd(node, caretPos - charIndex);
                        foundStart = true;
                    }
                    charIndex = nextCharIndex;
                } else {
                    let i = node.childNodes.length;
                    while (i--) {
                        nodeStack.push(node.childNodes[i]);
                    }
                }
            }

            if (foundStart) {
                selection.removeAllRanges();
                selection.addRange(range);
            }
        },
        handleVisualInputMyLink(event) {
            const content = event.target.innerHTML;
            if (this.updateTimer) {
                clearTimeout(this.updateTimer);
            }
            this.updateTimer = setTimeout(() => {
                if (content !== this.Diceconfig.myLinkHtml) {
                    this.Diceconfig.myLinkHtml = content;
                }
            }, 300);
        },
        handleCompositionStartMyLink() {
            this.isComposing = true;
        },
        handleCompositionEndMyLink(event) {
            this.isComposing = false;
            const content = event.target.innerHTML;
            if (this.updateTimer) {
                clearTimeout(this.updateTimer);
            }
            if (content !== this.Diceconfig.myLinkHtml) {
                this.Diceconfig.myLinkHtml = content;
            }
        },
        handlePasteMyLink() {
            // 让浏览器处理粘贴
        },
        handleKeydownMyLink() {
            // 让浏览器处理按键
        },
        setVisualEditorContentMyLink(content) {
            if (this.$refs.visualEditorMyLink && !this.isSourceModeMyLink) {
                this.$refs.visualEditorMyLink.innerHTML = content || '';
            }
        },

        // 第二个富文本编辑器的方法（邀请成功提示内容）
        insertHtmlSuccess(tag, closeTag) {
            if (this.isSourceModeSuccess) {
                const textarea = this.$refs.htmlTextareaSuccess.$refs.textarea;
                if (!textarea) return;

                const start = textarea.selectionStart;
                const end = textarea.selectionEnd;
                const selectedText = this.Diceconfig.successHtml.substring(start, end);
                let replacement = selectedText;
                let preSelection = 0;
                let postSelection = 0;

                if (selectedText.length > 0) {
                    replacement = tag + selectedText + (closeTag || '');
                    preSelection = tag.length;
                    postSelection = (closeTag || '').length;
                } else {
                    replacement = tag + (closeTag || '');
                    preSelection = tag.length;
                }

                this.Diceconfig.successHtml = this.Diceconfig.successHtml.substring(0, start) + replacement + this.Diceconfig.successHtml.substring(end);

                this.$nextTick(() => {
                    textarea.focus();
                    if (selectedText.length === 0) {
                        const newCursorPos = start + preSelection;
                        textarea.setSelectionRange(newCursorPos, newCursorPos);
                    } else {
                        const newStart = start + preSelection;
                        const newEnd = start + replacement.length - postSelection;
                        textarea.setSelectionRange(newStart, newEnd);
                    }
                });
            } else {
                const visualEditor = this.$refs.visualEditorSuccess;
                if (!visualEditor) return;

                visualEditor.focus();

                if (tag === '<br>') {
                    document.execCommand('insertHTML', false, '<br>');
                } else if (tag === '<b>') {
                    document.execCommand('bold', false, null);
                } else if (tag === '<i>') {
                    document.execCommand('italic', false, null);
                } else if (tag === '<u>') {
                    document.execCommand('underline', false, null);
                } else if (tag === '<h1>') {
                    document.execCommand('formatBlock', false, 'h1');
                } else if (tag === '<h2>') {
                    document.execCommand('formatBlock', false, 'h2');
                } else if (tag === '<ul><li>') {
                    document.execCommand('insertUnorderedList', false, null);
                } else if (tag === '<ol><li>') {
                    document.execCommand('insertOrderedList', false, null);
                }

                this.Diceconfig.successHtml = visualEditor.innerHTML;
            }
        },
        toggleModeSuccess() {
            this.isSourceModeSuccess = !this.isSourceModeSuccess;
            if (!this.isSourceModeSuccess) {
                this.$nextTick(() => {
                    this.setVisualEditorContentSuccess(this.Diceconfig.successHtml);
                });
            }
        },
        handleVisualInputSuccess(event) {
            const content = event.target.innerHTML;
            if (this.updateTimer) {
                clearTimeout(this.updateTimer);
            }
            this.updateTimer = setTimeout(() => {
                if (content !== this.Diceconfig.successHtml) {
                    this.Diceconfig.successHtml = content;
                }
            }, 300);
        },
        handleCompositionStartSuccess() {
            this.isComposing = true;
        },
        handleCompositionEndSuccess(event) {
            this.isComposing = false;
            const content = event.target.innerHTML;
            if (this.updateTimer) {
                clearTimeout(this.updateTimer);
            }
            if (content !== this.Diceconfig.successHtml) {
                this.Diceconfig.successHtml = content;
            }
        },
        handlePasteSuccess() {
            // 让浏览器处理粘贴
        },
        handleKeydownSuccess() {
            // 让浏览器处理按键
        },
        setVisualEditorContentSuccess(content) {
            if (this.$refs.visualEditorSuccess && !this.isSourceModeSuccess) {
                this.$refs.visualEditorSuccess.innerHTML = content || '';
            }
        },



        // 显示添加按钮对话框
        showAddButtonDialog(rowIndex, btnListType = 'success') {
            // 使用成功按钮列表
            const btnList = this.Diceconfig.successBtnList;

            // 检查是否超过每行最大按钮数限制
            if (rowIndex !== -1 && btnList[rowIndex] && btnList[rowIndex].length >= 5) {
                this.$message.warning('每一行最多允许5个按钮');
                return;
            }

            // 重置编辑状态
            this.editingButtonRowIndex = -1;
            this.editingButtonIndex = -1;
            this.currentBtnListType = btnListType;

            this.currentRowIndex = rowIndex;
            this.buttonForm = {
                text: '',
                url: ''
            };
            this.buttonDialogVisible = true;
        },
        // 获取对话框标题
        getDialogTitle() {
            const btnList = this.Diceconfig.successBtnList;
            const listName = '成功提示';

            if (this.editingButtonIndex !== -1) {
                // 编辑模式
                const rowNum = this.editingButtonRowIndex + 1;
                const btnNum = this.editingButtonIndex + 1;
                return `编辑${listName}第${rowNum}行第${btnNum}个按钮`;
            } else if (this.currentRowIndex === -1) {
                return `新增${listName}一行按钮`;
            } else {
                // 检查行是否存在，防止访问已删除的行
                if (btnList[this.currentRowIndex]) {
                    const rowNum = this.currentRowIndex + 1;
                    const btnNum = btnList[this.currentRowIndex].length + 1;
                    return `${listName}第${rowNum}行第${btnNum}个按钮`;
                } else {
                    return `新增${listName}一行按钮`;
                }
            }
        },
        // 确认添加按钮
        confirmAddButton() {
            // 验证表单
            this.$refs.buttonFormRef.validate((valid) => {
                if (!valid) {
                    return;
                }

                const buttonData = {
                    text: this.buttonForm.text.trim(),
                    url: this.buttonForm.url.trim()
                };

                // 使用成功按钮列表
                const btnList = this.Diceconfig.successBtnList;

                if (this.editingButtonIndex !== -1) {
                    // 编辑模式：更新现有按钮
                    btnList[this.editingButtonRowIndex][this.editingButtonIndex] = buttonData;
                    this.$message.success('按钮编辑成功');

                    // 重置编辑状态
                    this.editingButtonRowIndex = -1;
                    this.editingButtonIndex = -1;
                } else if (this.currentRowIndex === -1) {
                    // 新增一行按钮
                    btnList.push([buttonData]);
                    this.$message.success('按钮添加成功');
                } else {
                    // 在指定行添加按钮 - 检查行是否存在
                    if (btnList[this.currentRowIndex]) {
                        btnList[this.currentRowIndex].push(buttonData);
                        this.$message.success('按钮添加成功');
                    } else {
                        // 如果指定行不存在，创建新行
                        btnList.push([buttonData]);
                        this.$message.success('按钮添加成功');
                    }
                }

                this.buttonDialogVisible = false;
            });
        },

        // 拖拽相关方法
        handleDragStart(rowIndex) {
            this.draggedRowIndex = rowIndex;
        },

        handleDragEnd() {
            this.draggedRowIndex = null;
        },

        handleDragOver(event) {
            event.preventDefault();
        },

        handleDrop(event, targetRowIndex, btnListType = 'success') {
            event.preventDefault();
            event.stopPropagation();

            if (this.draggedRowIndex === null || this.draggedRowIndex === targetRowIndex) {
                return;
            }

            const fromIndex = this.draggedRowIndex;
            const toIndex = targetRowIndex;

            // 使用成功按钮列表
            const btnList = this.Diceconfig.successBtnList;

            // 移动按钮行 - 创建新数组强制响应式更新
            const newButtons = [...btnList];
            const draggedRow = newButtons[fromIndex];

            // 移除原位置的行
            newButtons.splice(fromIndex, 1);
            // 插入到新位置
            newButtons.splice(toIndex, 0, draggedRow);

            // 替换整个数组触发响应式更新
            this.Diceconfig.successBtnList = newButtons;

            // 强制Vue重新渲染
            this.$nextTick(() => {
                this.$forceUpdate();
            });

            this.$message.success(`第${fromIndex + 1}行已移动到第${toIndex + 1}行`);
        },

        // 解析按钮文本数据为二维数组
        parseButtonData(buttonText) {
            if (!buttonText || typeof buttonText !== 'string') {
                return [];
            }

            try {
                // 1. 按换行符分割成行
                const lines = buttonText.split('\n').filter(line => line.trim());

                // 2. 每行按分号分割成按钮
                const buttons = lines.map(line => {
                    return line.split(';').filter(item => item.trim()).map(item => {
                        // 3. 解析每个按钮的文字和链接 格式: 文字(链接)
                        const match = item.trim().match(/^(.+?)\((.+?)\)$/);
                        if (match) {
                            return {
                                text: match[1].trim(),
                                url: match[2].trim()
                            };
                        }
                        return null;
                    }).filter(Boolean);
                }).filter(row => row.length > 0);

                return buttons;
            } catch (error) {
                console.error('解析按钮数据失败:', error);
                return [];
            }
        },


        // 初始化富文本编辑器
        initRichTextEditor() {
            this.$nextTick(() => {
                // 初始化第一个富文本编辑器（我的链接回复内容）
                if (this.$refs.visualEditorMyLink && !this.isSourceModeMyLink) {
                    this.$refs.visualEditorMyLink.innerHTML = this.Diceconfig.myLinkHtml || '';
                }

                // 初始化第二个富文本编辑器（邀请成功提示内容）
                if (this.$refs.visualEditorSuccess && !this.isSourceModeSuccess) {
                    this.$refs.visualEditorSuccess.innerHTML = this.Diceconfig.successHtml || '';
                }
            });
        },
        removeButtonRow(rowIndex, btnListType = 'success') {
            const btnList = this.Diceconfig.successBtnList;
            btnList.splice(rowIndex, 1);
        },

        // 邀请详情相关方法
        async handleDetail(row) {
            this.currentqiNum = row.qiNum;
            this.currentGroupId = row.groupid;
            this.detailDialogVisible = true;
            this.diceuserHisCurrentPage = 1;
            await this.fetchDiceuserHis();
        },

        async handleOpen(row) {
            try {
                await this.$confirm('确定要开奖吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })

                const response = await api.openDicegame(row.id)
                if (response.data.code === 0) {
                    this.$message.success('开奖成功')
                    this.fetchData()
                } else {
                    this.$message.error(response.data.message || '开奖失败')
                }
            } catch (error) {
                if (error !== 'cancel') {
                    console.error('开奖失败:', error)
                    this.$message.error('开奖失败')
                }
            }
        },

        async fetchDiceuserHis() {
            if (!this.currentqiNum || !this.currentGroupId) return;

            this.diceuserHisLoading = true;
            try {
                const params = {
                    page: this.diceuserHisCurrentPage,
                    pageSize: this.diceuserHisPageSize,
                    userBot: this.currentUserInfo.userBot,
                    groupid: this.currentGroupId,
                    qiNum: this.currentqiNum
                };
                const response = await api.getDiceuserHisList(params);
                if (response.data.code === 0) {
                    this.diceuserHisData = response.data.data.records || [];
                    this.diceuserHisTotal = response.data.data.total || 0;
                } else {
                    this.$message.error(response.data.message || '获取骰子游戏用户参与数据失败');
                }
            } catch (error) {
                console.error('获取骰子游戏用户参与数据失败:', error);
                this.$message.error('获取骰子游戏用户参与数据失败');
            } finally {
                this.diceuserHisLoading = false;
            }
        },

        handleInviteUsersPageChange(page) {
            this.diceuserHisCurrentPage = page;
            this.fetchDiceuserHis();
        },

        handleInviteUsersSizeChange(size) {
            this.diceuserHisPageSize = size;
            this.diceuserHisCurrentPage = 1;
            this.fetchDiceuserHis();
        },

        formatInviteTime(time) {
            if (!time) return '-';
            return new Date(time).toLocaleString('zh-CN');
        },
        getChoiceTagType(choice) {
            switch (choice) {
                case '大':
                    return 'success';
                case '小':
                    return 'danger';
                case '单':
                    return 'warning';
                case '双':
                    return 'info';
                default:
                    return '';
            }
        }
    },
    mounted() {
        if (this.$store.state.user) {
            this.loadUserInfo(this.$store.state.user);
            this.fetchData()
            this.fetchSetting()
        }
        this.initRichTextEditor();
    }
}
</script>

<style scoped>
.auto-reply {
    padding: 20px;
}

.search-section {
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    margin-bottom: 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.button-group {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
}

.stats-section {
    margin-bottom: 20px;
}

.stats-card {
    text-align: center;
}

.stats-item {
    padding: 10px;
}

.stats-value {
    font-size: 24px;
    font-weight: bold;
    color: #409eff;
    margin-bottom: 5px;
}

.stats-label {
    font-size: 14px;
    color: #666;
}

.keyword-display {
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.keyword-desc {
    margin-top: 5px;
}

.reply-content {
    max-width: 300px;
    word-break: break-all;
}

.media-url {
    margin-top: 5px;
    padding: 5px;
    background: #f5f5f5;
    border-radius: 4px;
}

.advanced-settings {
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.pagination {
    margin-top: 20px;
    text-align: center;
}

.dialog-footer {
    text-align: right;
}

.upload-demo {
    text-align: center;
}

.el-upload__tip {
    color: #666;
    font-size: 12px;
    margin-top: 10px;
}

.placeholder-description {
    font-size: 12px;
    color: #999;
    margin-top: 10px;
    line-height: 1.5;
}

.button-input-area {
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    padding: 10px;
    min-height: 60px;
    margin-bottom: 10px;
}

.button-row {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
}

.button-item {
    display: flex;
    align-items: center;
    gap: 5px;
}

.button-controls {
    display: flex;
    gap: 10px;
}

.delete-row-btn {
    background-color: #fee;
    color: #f56c6c;
    border-color: #fde2e2;
}

.delete-row-btn:hover {
    background-color: #fdd;
    color: #f23c3c;
}

.other-settings {
    margin-top: 15px;
}

.setting-label {
    color: var(--el-text-color-regular);
    margin-right: 12px;
}

.form-label-with-icon {
    display: flex;
    align-items: center;
    gap: 4px;
}

.required-asterisk {
    color: var(--el-color-danger);
    margin-right: 4px;
}

.condition-input-group {
    display: flex;
    align-items: center;
    width: 100%;
    gap: 10px;
}

.reply-content-head {
    display: flex;
    align-items: flex-start;
}

.keyword-tags-input {
    flex-grow: 1;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 5px;
    border: 1px solid var(--el-border-color);
    border-radius: 4px;
    padding: 2px 8px;
    min-height: 32px;
    max-width: 350px;
}

.keyword-new-tag-input {
    border: none;
    outline: none;
    flex-grow: 1;
    min-width: 80px;
    background-color: transparent;
}

.html-editor {
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    background: white;
    max-width: 460px;
}

.html-textarea {
    width: 100%;
    max-width: 460px;
}

.html-textarea :deep(.el-textarea__inner) {
    max-height: 200px;
    min-height: 120px;
    resize: vertical;
    word-wrap: break-word;
    overflow-wrap: break-word;
}

.html-toolbar {
    display: flex;
    align-items: center;
    padding: 8px 12px;
    border-bottom: 1px solid #dcdfe6;
    background: #f5f7fa;
    flex-wrap: wrap;
    gap: 4px;
}

.html-toolbar button {
    padding: 4px 8px;
    border: 1px solid #dcdfe6;
    background: white;
    border-radius: 3px;
    cursor: pointer;
    font-size: 12px;
    transition: all 0.2s;
    min-width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.html-toolbar button:hover:not(:disabled) {
    background: #ecf5ff;
    border-color: #409eff;
}

.html-toolbar button.is-active {
    background: #409eff;
    color: white;
    border-color: #409eff;
}

.html-toolbar button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background: #f5f7fa;
}

.html-toolbar .divider {
    margin: 0 8px;
    color: #dcdfe6;
}

.editor-content-area {
    border: 1px solid #dcdfe6;
    border-top: none;
    border-radius: 0 0 4px 4px;
}

.visual-editor {
    min-height: 50px;
    max-height: 200px;
    height: 200px;
    padding: 12px;
    outline: none;
    cursor: text;
    line-height: 1.6;
    font-size: 14px;
    background: white;
    border-radius: 0 0 4px 4px;
    direction: ltr;
    text-align: left;
    unicode-bidi: normal;
    overflow-y: auto;
    word-wrap: break-word;
    overflow-wrap: break-word;
    box-sizing: border-box;
}

.visual-editor:focus {
    outline: none;
}

.visual-editor p {
    margin: 8px 0;
}

.visual-editor p:first-child {
    margin-top: 0;
}

.visual-editor p:last-child {
    margin-bottom: 0;
}

.visual-editor h1,
.visual-editor h2,
.visual-editor h3 {
    margin: 16px 0 8px 0;
    font-weight: bold;
}

.visual-editor h1 {
    font-size: 1.5em;
}

.visual-editor h2 {
    font-size: 1.3em;
}

.visual-editor ul,
.visual-editor ol {
    padding-left: 20px;
    margin: 8px 0;
}

.visual-editor li {
    margin: 4px 0;
}

.visual-editor strong,
.visual-editor b {
    font-weight: bold;
}

.visual-editor em,
.visual-editor i {
    font-style: italic;
}

.visual-editor u {
    text-decoration: underline;
}

.visual-editor[contenteditable]:empty:before {
    content: "请输入回复内容...";
    color: #c0c4cc;
    font-style: italic;
}

.reply-type-horizontal {
    display: flex;
    align-items: center;
    gap: 20px;
    flex-wrap: nowrap;
}

.type-select-container {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
    min-width: 250px;
}

.media-url-container {
    display: flex;
    align-items: center;
    gap: 10px;
    flex: 1;
    min-width: 350px;
    padding: 4px 8px;
    background-color: #f8f9fa;
    border-radius: 4px;
    border-left: 3px solid #409eff;
    animation: slideInRight 0.3s ease-out;
}

@keyframes slideInRight {
    from {
        opacity: 0;
        transform: translateX(20px);
    }

    to {
        opacity: 1;
        transform: translateX(0);
    }
}

.reply-type-dropdown {
    max-height: 200px;
    overflow-y: auto;
    z-index: 9999;
}

/* 按钮行列表样式 */
.button-rows-list {
    margin-bottom: 2px;
}

.button-row-wrapper {
    display: flex;
    align-items: center;
    gap: 15px;
    margin-bottom: 2px;
    margin-left: 35px;
    /* 与新增一行按钮对齐 */
    border-radius: 6px;
    padding: 6px;
    transition: all 0.3s ease;
}

.button-row-wrapper.drag-over {
    background-color: #f0f9ff;
    border: 2px dashed #1890ff;
    transform: scale(1.02);
}

.gray-buttons-container {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: nowrap;
    /* 不允许换行 */
    width: 480px;
    /* 与新增一行按钮宽度一致 */
    flex-shrink: 0;
    /* 不允许收缩 */
}

.button-item {
    background: #a8a8a8;
    color: white;
    padding: 8px 16px;
    border-radius: 4px;
    font-size: 14px;
    text-align: center;
    border: none;
    cursor: default;
    white-space: nowrap;
    /* 文字不换行 */
    flex: 1;
    /* 弹性宽度，平均分配空间 */
    min-width: 0;
    /* 允许收缩到内容宽度 */
    overflow: hidden;
    /* 防止内容溢出 */
    text-overflow: ellipsis;
    /* 文字过长时显示省略号 */
    position: relative;
    /* 为操作按钮定位提供参考 */
    transition: all 0.3s ease;
    height: 36px;
    /* 确保与蓝色按钮高度一致 */
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
}

.button-item:hover {
    background: #909399;
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.button-actions {
    position: absolute;
    top: 50%;
    right: 8px;
    transform: translateY(-50%);
    display: flex;
    gap: 4px;
    opacity: 0;
    transition: opacity 0.2s ease;
    z-index: 2;
}

.button-item:hover .button-actions {
    opacity: 1;
}

.button-action-icon {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;
}

.edit-icon {
    background: #409eff;
}

.edit-icon:hover {
    background: #66b1ff;
    transform: scale(1.1);
}

.delete-icon {
    background: #f56c6c;
}

.delete-icon:hover {
    background: #f78989;
    transform: scale(1.1);
}

.button-action-icon .el-icon {
    font-size: 12px;
    color: white;
}

.add-button-container {
    display: flex;
    align-items: center;
    flex-shrink: 0;
}

.add-to-row-button {
    background: #1890ff;
    color: white;
    border: none;
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    white-space: nowrap;
    transition: background-color 0.3s ease;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
}

.add-to-row-button:hover {
    background: #40a9ff;
}

/* 新增按钮样式 */
.button-controls {
    display: flex;
    align-items: center;
    padding: 0;
}

.add-row-button {
    border: 1px dashed #d9d9d9;
    background: #fff;
    color: #666;
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    transition: all 0.3s;
    outline: none;
    min-width: 480px;
    height: 36px;
    margin-left: 35px;
}

.add-row-button:hover {
    border-color: #1890ff;
    color: #1890ff;
}

.drag-icon-container {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    cursor: grab;
    user-select: none;
}

.drag-icon-container:active {
    cursor: grabbing;
}

.drag-icon {
    font-size: 16px;
    color: #8c8c8c;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: color 0.3s ease;
}

.drag-icon-container:hover .drag-icon {
    color: #1890ff;
}

.drag-icon-container[draggable="true"] {
    cursor: grab;
}

.drag-icon-container[draggable="true"]:active {
    cursor: grabbing;
}

/* 变量说明样式 */
.variable-help-text {
    margin-top: -10px;
    margin-bottom: 20px;
    margin-left: 120px;
    max-width: 430px;
    /* 与表单标签对齐 */
    padding: 12px 16px;
    background-color: #f8f9fa;
    border: 1px solid #e9ecef;
    border-radius: 6px;
    font-size: 13px;
    line-height: 1.6;
    color: #6c757d;
}

.variable-item {
    display: inline;
}

.variable-help-text code {
    background-color: #e3f2fd;
    color: #1976d2;
    padding: 2px 6px;
    border-radius: 3px;
    font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
    font-size: 12px;
    font-weight: 600;
    border: 1px solid #bbdefb;
}

.carousel-tabs .el-tabs__item {
    font-size: 18px;
    font-weight: bold;
    padding: 16px 40px 12px 40px;
}

.carousel-banner {
    background: linear-gradient(90deg, #6a82fb 0%, #fc5c7d 100%);
    color: #fff;
    border-radius: 18px 18px 0 0;
    padding: 36px 36px 18px 36px;
    text-align: left;
    margin-bottom: -18px;
    box-shadow: 0 4px 24px rgba(100, 100, 100, 0.10);
}

.carousel-banner-title {
    font-size: 2.2rem;
    font-weight: bold;
    letter-spacing: 2px;
}

.carousel-banner-desc {
    font-size: 1.1rem;
    opacity: 0.90;
    margin-top: 10px;
}

.carousel-setting-card {
    border-radius: 18px;
    box-shadow: 0 2px 18px rgba(100, 100, 100, 0.10);
    padding: 38px 28px 28px 28px;
    margin-top: 0;
}

.form-section-title {
    font-size: 1.15rem;
    font-weight: 600;
    margin: 28px 0 10px 0;
    color: #6a82fb;
    letter-spacing: 1px;
}

.big-switch :deep(.el-switch__core) {
    width: 56px !important;
    height: 28px !important;
    border-radius: 18px !important;
}

.big-switch :deep(.el-switch__action) {
    width: 28px !important;
    height: 28px !important;
}

.big-submit-btn {
    width: 280px;
    background: linear-gradient(90deg, #6a82fb 0%, #fc5c7d 100%);
    border: none;
    border-radius: 10px;
    font-size: 1.15rem;
    font-weight: bold;
    box-shadow: 0 2px 8px rgba(252, 92, 125, 0.12);
    padding: 14px 0;
    margin-top: 18px;
}

/* 拖拽上传样式 */
.json-upload-drag {
    width: 100%;
}

.json-upload-drag :deep(.el-upload-dragger) {
    width: 100%;
    height: 120px;
    border: 2px dashed #d9d9d9;
    border-radius: 8px;
    background: #fafafa;
    transition: all 0.3s ease;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.json-upload-drag :deep(.el-upload-dragger:hover) {
    border-color: #409eff;
    background: #f0f9ff;
}

.json-upload-drag :deep(.el-upload-dragger.is-dragover) {
    border-color: #409eff;
    background: #e6f7ff;
    transform: scale(1.02);
}

.json-upload-drag :deep(.el-icon--upload) {
    font-size: 28px;
    color: #c0c4cc;
    margin-bottom: 8px;
    transition: color 0.3s ease;
}

.json-upload-drag :deep(.el-upload-dragger:hover .el-icon--upload) {
    color: #409eff;
}

.json-upload-drag :deep(.el-upload__text) {
    color: #606266;
    font-size: 14px;
    text-align: center;
    line-height: 1.5;
}

.json-upload-drag :deep(.el-upload__text em) {
    color: #409eff;
    font-style: normal;
    font-weight: bold;
}

.json-upload-drag :deep(.el-upload__tip) {
    color: #888;
    font-size: 12px;
    line-height: 1.6;
    margin-top: 8px;
    text-align: center;
}

.media-group-manager {
    display: flex;
    flex-direction: column;
    gap: 15px;
    min-height: 200px;
}

.media-item {
    padding: 15px;
    background: #f8f9fa;
    border-radius: 8px;
    border: 1px solid #e9ecef;
}

.media-item-content {
    display: flex;
    align-items: center;
    gap: 12px;
}

.media-index {
    font-weight: bold;
    color: #409eff;
    min-width: 30px;
}

.add-media-section {
    display: flex;
    justify-content: center;
    padding: 20px;
    border: 2px dashed #d9d9d9;
    border-radius: 8px;
    background: #fafafa;
}

.add-media-section:hover {
    border-color: #409eff;
    background: #f0f9ff;
}

.media-management-container {
    display: flex;
    align-items: center;
    margin-top: 10px;
}

/* 3D骰子样式 */
.dice-container {
    display: flex;
    align-items: center;
    gap: 12px;
}

.dice {
    width: 40px;
    height: 40px;
    background: linear-gradient(145deg, #ffffff, #e6e6e6);
    border: 2px solid #d0d0d0;
    border-radius: 8px;
    box-shadow:
        0 4px 8px rgba(0, 0, 0, 0.1),
        inset 0 1px 0 rgba(255, 255, 255, 0.8),
        inset 0 -1px 0 rgba(0, 0, 0, 0.1);
    position: relative;
    transform: rotateX(15deg) rotateY(15deg);
    transition: all 0.3s ease;
    cursor: pointer;
}

.dice:hover {
    transform: rotateX(20deg) rotateY(20deg) scale(1.1);
    box-shadow:
        0 8px 16px rgba(0, 0, 0, 0.15),
        inset 0 1px 0 rgba(255, 255, 255, 0.9),
        inset 0 -1px 0 rgba(0, 0, 0, 0.15);
}

.dice-inner {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

.dice-dots {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(3, 1fr);
    gap: 2px;
    width: 100%;
    height: 100%;
    padding: 4px;
}

.dot {
    width: 6px;
    height: 6px;
    background: #333;
    border-radius: 50%;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

/* 骰子点数布局 */
.dice-1 .dice-dots {
    grid-template-areas:
        ". . ."
        ". center ."
        ". . .";
}

.dice-1 .dot:nth-child(1) {
    grid-area: center;
}

.dice-2 .dice-dots {
    grid-template-areas:
        "top-left . ."
        ". . ."
        ". . bottom-right";
}

.dice-2 .dot:nth-child(1) {
    grid-area: top-left;
}

.dice-2 .dot:nth-child(2) {
    grid-area: bottom-right;
}

.dice-3 .dice-dots {
    grid-template-areas:
        "top-left . ."
        ". center ."
        ". . bottom-right";
}

.dice-3 .dot:nth-child(1) {
    grid-area: top-left;
}

.dice-3 .dot:nth-child(2) {
    grid-area: center;
}

.dice-3 .dot:nth-child(3) {
    grid-area: bottom-right;
}

.dice-4 .dice-dots {
    grid-template-areas:
        "top-left . top-right"
        ". . ."
        "bottom-left . bottom-right";
}

.dice-4 .dot:nth-child(1) {
    grid-area: top-left;
}

.dice-4 .dot:nth-child(2) {
    grid-area: top-right;
}

.dice-4 .dot:nth-child(3) {
    grid-area: bottom-left;
}

.dice-4 .dot:nth-child(4) {
    grid-area: bottom-right;
}

.dice-5 .dice-dots {
    grid-template-areas:
        "top-left . top-right"
        ". center ."
        "bottom-left . bottom-right";
}

.dice-5 .dot:nth-child(1) {
    grid-area: top-left;
}

.dice-5 .dot:nth-child(2) {
    grid-area: top-right;
}

.dice-5 .dot:nth-child(3) {
    grid-area: center;
}

.dice-5 .dot:nth-child(4) {
    grid-area: bottom-left;
}

.dice-5 .dot:nth-child(5) {
    grid-area: bottom-right;
}

.dice-6 .dice-dots {
    grid-template-areas:
        "top-left . top-right"
        "middle-left . middle-right"
        "bottom-left . bottom-right";
}

.dice-6 .dot:nth-child(1) {
    grid-area: top-left;
}

.dice-6 .dot:nth-child(2) {
    grid-area: top-right;
}

.dice-6 .dot:nth-child(3) {
    grid-area: middle-left;
}

.dice-6 .dot:nth-child(4) {
    grid-area: middle-right;
}

.dice-6 .dot:nth-child(5) {
    grid-area: bottom-left;
}

.dice-6 .dot:nth-child(6) {
    grid-area: bottom-right;
}

.dice-number {
    font-size: 14px;
    font-weight: 600;
    color: #606266;
    background: #f5f7fa;
    padding: 4px 8px;
    border-radius: 4px;
    border: 1px solid #e4e7ed;
}
</style>